import { render, staticRenderFns } from "./UpDejunFixedValues.vue?vue&type=template&id=2815fb50&"
import script from "./UpDejunFixedValues.vue?vue&type=script&lang=js&"
export * from "./UpDejunFixedValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports